{
  "anySpecialist": {
    "text": "请显示所有可预约的时间范围。",
    "title": "我都可以"
  },
  "nextLabel": "$t(common:next): <b>请选择时间</b>",
  "profile": "专科医生简介",
  "specialists": {
    "00000000-0000-da7a-0003-000000000004": {
      "name": "Dr. Lopez"
    }
  },
  "textMultiple": "<p>这些专科医生都是很好的选择。请选择其中一位，或者继续点击“我都可以”。</p>",
  "textSingle": "<p>您的全科医生 – {{referral.gp}} – 已将您转诊至：</p>",
  "titleMultiple": "请选择您的专科医生",
  "titleSingle": "您的专科医生",
  "viewProfile": "查看完整资料"
}
